import { Alignments, AlignmentsFormat } from 'rich-text-lib/constants/alignments';
import { ImageAlignmentClasses } from 'rich-text-lib/constants/image';
import { LazyLoadingTypes } from 'rich-text-lib/constants/shared';
import { getPluginSetting } from '../utils';
import { IMAGE_SETTINGS, hsimageConfig, FileSource } from '../constants/image';
export function isEditableImage(editor, node) {
  return editor.dom.is(node, 'img:not([data-mce-object],[data-mce-placeholder])');
}
export function imageIsOnlyChild(editor, node) {
  if (isEditableImage(editor, node)) return true;
  const childNodes = Array.from(node.childNodes).filter(childNode => {
    if (childNode.nodeType === 3 && childNode.textContent && childNode.textContent.trim() === '') {
      return false;
    }
    return true;
  });
  if (childNodes.length === 1) {
    return imageIsOnlyChild(editor, childNodes[0]);
  }
  return false;
}
export function getImagePluginSetting(editor, setting) {
  const imagePluginSettings = getPluginSetting(editor, IMAGE_SETTINGS);
  if (imagePluginSettings) {
    return imagePluginSettings[setting];
  }
  return null;
}
export function getImageLoadingDefaultValue(editor) {
  const imagePluginSettings = getPluginSetting(editor, IMAGE_SETTINGS);
  const setting = hsimageConfig.IMAGE_LOADING_DEFAULT_VALUE;
  if (imagePluginSettings && typeof imagePluginSettings[setting] !== 'undefined') {
    return getImagePluginSetting(editor, setting);
  }
  return getPluginSetting(editor, 'isEmail') ? LazyLoadingTypes.default : LazyLoadingTypes.lazy;
}
export const getImageAlignment = (editor, image) => {
  const useAlignmentClasses = !!getImagePluginSetting(editor, hsimageConfig.USE_ALIGNMENT_CLASSES);
  if (useAlignmentClasses) {
    const alignmentKey = Object.keys(ImageAlignmentClasses).find(key => editor.dom.hasClass(image, ImageAlignmentClasses[key]));
    return alignmentKey || Alignments.NONE;
  }
  return Object.values(Alignments).find(alignment => editor.formatter.matchNode(image, AlignmentsFormat[alignment])) || Alignments.NONE;
};
export const updateImageAlignmentClass = (editor, image, className) => {
  const imageClasses = Object.values(ImageAlignmentClasses);
  const classes = image.className.split(' ').filter(el => !imageClasses.includes(el));
  classes.push(className);
  editor.dom.setAttrib(image, 'class', classes.join(' ').trim());
};
export const getMarginValue = (image, computedStyle, property) => {
  const marginStyle = image.style.getPropertyValue(property);
  if (marginStyle.includes('%') || marginStyle.includes('auto')) {
    return marginStyle;
  }
  return parseInt(computedStyle.getPropertyValue(property), 10) || 0;
};
export const retainAttributesOfReplacedImage = (editor, imageToReplace, newWidth, newHeight) => {
  let width = newWidth;
  let height = newHeight;
  let styles = {};
  let className;
  let loading;
  if (imageToReplace) {
    width = Math.min(imageToReplace.width, newWidth);
    height = Math.round(newHeight / newWidth * width);
    styles = editor.dom.parseStyle(imageToReplace.getAttribute('style') || '');
    className = imageToReplace.className;
    loading = editor.dom.getAttrib(imageToReplace, 'loading');
  }
  return {
    width,
    height,
    styles,
    className,
    loading
  };
};
export function getAltTextForFile(file, useCustomAltText) {
  if (useCustomAltText && file.meta && file.meta.title) {
    return file.meta.title;
  }
  return file.name;
}
export const getIsImageAiGenerated = file => Boolean(file.meta && 'ai_generated' in file.meta && file.meta.ai_generated);
export const isShutterstock = file => Boolean(file.meta && 'shutterstock_id' in file.meta && file.meta.shutterstock_id);
export const isCanvaGenerated = file => Boolean(file.meta && 'canva_id' in file.meta && file.meta.canva_id);
export const getFileSource = file => {
  if (getIsImageAiGenerated(file)) {
    return FileSource.AI_GENERATED;
  } else if (isCanvaGenerated(file)) {
    return FileSource.CANVA;
  } else if (isShutterstock(file)) {
    return FileSource.SHUTTERSTOCK;
  }
  return null;
};